<template>
    <div v-if="user" id="licenses-view-container" class="align-self-center h-full w-full" style="margin-top: 2.5rem;">
        <div v-if="!httpGetApplicationLicensesLoading && myCurrentActivationsSerials!=null" class="h-full">
            <div class="w-full m-0 p-0 flex flex-column">
                
                <!-- ACTION BAR -->
                <div class="flex flex-row justify-content-between w-full mb-3">
                    <!-- Left -->
                    <div class="left flex flex-row gap-1 align-items-center">
                        <Dropdown v-model="selectionStatus" :options="optionsStatus" placeholder="Status Filter" style="min-width: 11.5rem; height: 1.8125rem;" class="mr-3">
                            <template #value="slotProps">
                                <div class="flex flex-row align-items-center justify-content-start w-full" style="height: 1.6875rem;">
                                    <StatusTag v-if="slotProps.value && slotProps.value != 'ALL'" :mockStatus="slotProps.value"/>
                                    <div v-else class="flex flex-row align-items-center px-1">{{ slotProps.placeholder }}</div>
                                </div>
                            </template>
                            <template #option="slotProps">
                                <span v-if="!slotProps.option || (slotProps.option && slotProps.option == 'ALL')" class="px-1" style="font-style: italic;">None</span>
                                <StatusTag v-else :mockStatus="slotProps.option"/>
                            </template>
                            <template #clearicon>
                                <SvgCross class="align-self-center" className="inputcomponent-right-svg" color="var(--theme-font-color)" @click="selectionStatus = null;"/>
                            </template>
                        </Dropdown>

                        <div class="flex flex-row gap-3 align-items-center h-full mr-3">
                            <!-- Search bar -->
                            <span class="p-input-icon-left p-input-icon-right h-full flex align-items-center">
                                <SvgSearch className="inputcomponent-right-svg" color="var(--theme-font-color)" style="top: 1.03rem;"/>
                                <InputText id="searchInputText" ref="searchInputText" v-model="searchValue" placeholder="Search Filter" type="text" style="padding-left: 2.1rem !important; padding-right: 2.1rem !important;"/>
                                <SvgCross class="align-self-center" className="inputcomponent-right-svg" color="var(--theme-font-color)" @click="searchValue = ''; isSearching = false" style="top: 1.03rem;"/>
                            </span>
                        </div>

                        <Divider layout="vertical" style="padding: 0; padding-left: 0rem; padding-right: 0rem;"/>

                        <!-- Add Serial button -->
                        <Button text @click="showAddSerialNumberDialog = true">
                        <div class="flex flex-row w-full justify-content-center align-items-center gap-2">
                            <SvgPlus className="table-licenses-svg" color="var(--button-normal-color)"/>
                            <span>Add a Serial Number</span>
                        </div>
                        </Button>
                    </div>
                    <!-- Right -->
                    <div class="right flex flex-row justify-content-end align-items-center">
                        <Button rounded text @click="refreshApplicationLicenses" style="border-radius: 980px; padding: 0.5rem;">
                            <SvgRefresh className="table-licenses-svg" color="var(--button-normal-color)"/>
                        </Button>
                    </div>
                </div>

                <!-- TABLE -->
                <div class="licenses-table mt-0 w-full flex flex-column" style="flex: 1;">
                    <DataTable class="datatable-license mb-3" alwaysShowPaginator="" :value="myLicensesAfterFilteringAndPendingUpdatingSorted" size="small" tableStyle="min-width: 100%" :row-class="() => 'row'" scrollable scrollHeight="flex" :style="{ maxHeight: `${windowHeight - 270}px` }"
                        row resizableColumns columnResizeMode="fit"  
                    >
                        <template #empty>
                            <div v-if="myLicenses.length>0 && (searchValue || selectionStatus)" class="w-full flex flex-column justify-content-center align-items-center p-3" style="background-color: var(--table-row-color)">
                                <span>No license matches the filters applied.</span>
                                <span>Change or clear the <span style="font-weight: var(--font-weight-normal);">Status Filter</span> and <span style="font-weight: var(--font-weight-normal);">Search Filter</span> to see your licenses.</span>
                            </div>
                            <div v-else-if="receivedEmptyArray" class="w-full flex flex-column justify-content-center align-items-center p-3" style="background-color: var(--table-row-color)">
                                <span>No license found for this application. Click on <span style="font-weight: var(--font-weight-normal);">Add a Serial Number</span> button to add one.</span>
                                <span>If you already have licenses, they may not be for this application. Check the licenses you have in <span style="font-weight: var(--font-weight-normal);">Softron License Manager</span>.</span>
                            </div>
                            <div v-else class="w-full flex flex-row justify-content-center align-items center">
                                <LoadingSpinner/>
                            </div>
                        </template>
                        
                        <Column field="serial_number" style="width: 15%;" class="resize">
                            <template #header>
                                <div class="w-full flex flex-row align-items-center justify-content-center">
                                    <span class="p-column-title">Serial Number</span>
                                </div>
                            </template>
                            <template #body="slotProps">
                                <div class="flex flex-row align-items-center justify-content-center ml-2">
                                    <span class="potentially-long-label text-serial-number">{{slotProps.data.serial_number}}</span>
                                </div>
                            </template>
                        </Column>
                        <Column field="product" style="max-width: 40%;" class="resize">
                            <template #header>
                                <div class="w-full flex flex-row align-items-center justify-content-center">
                                    <span class="p-column-title">Description</span>
                                </div>
                            </template>
                            <template #body="slotProps">
                                <div class="flex flex-row align-items-center justify-content-center relative w-full" style="">
                                    <ScrollDescriptionText :type="slotProps.data.product.type" :version="slotProps.data.product.version" :exp="slotProps.data.product.exp" :options="slotProps.data.product.options"/>
                                </div>
                            </template>
                        </Column>
                        <Column field="product.channels" style="width: 10%;" class="resize">
                            <template #header>
                                <div class="w-full flex flex-row align-items-center justify-content-center">
                                    <span class="p-column-title">Channels</span>
                                </div>
                            </template>
                            <template #body="slotProps">
                                <div class="flex flex-row align-items-center justify-content-center">
                                    <span>{{slotProps.data.product.channels}}</span>
                                </div>
                            </template>
                        </Column>
                        <Column field="current_status" style="width: 20%;" class="resize">
                            <template #header>
                                <div class="w-full flex flex-row align-items-center justify-content-center">
                                    <span class="p-column-title">Status</span>
                                </div>
                            </template>
                            <template #body="slotProps">
                                <div class="flex flex-row align-items-center justify-content-center">
                                    <StatusTag :statusInformation="slotProps.data.current_status" :pending="isPendingNow(slotProps.data) ? slotProps.data.pending : null" tooltipPosition="left" tagSize="small" :serialNumber="slotProps.data.serial_number" :applicationName="slotProps.data.product.application"/>
                                </div>
                            </template>
                        </Column>
                        <Column field="current_status" style="width: 15%;">
                            <template #header>
                                <div class="w-full flex flex-row align-items-center justify-content-center">
                                    <span class="p-column-title">Action</span>
                                </div>
                            </template>
                            <template #body="slotProps">
                                <div class="w-full flex flex-row align-items-center justify-content-center">
                                    <ButtonModule v-if="isButtonActivate(slotProps.data)" type="primary" severity="normal" :label="(httpActivateLoading && currentlyProcessedSerialNumber === slotProps.data.serial_number) ? 'Activating...' : 'Activate'" @click="clickedActivate(slotProps.data)" :disabled="httpActivateLoading || httpDeactivateLoading || httpForceReleaseLoading"/>
                                    <ButtonModule v-else-if="isButtonRelease(slotProps.data)" type="primary" severity="normal" :label="((httpForceReleaseLoading || httpPingLoading) && currentlyProcessedSerialNumber === slotProps.data.serial_number) ? 'Releasing...' : 'Release'" @click="clickedRelease(slotProps.data.serial_number)" :disabled="httpActivateLoading || httpDeactivateLoading || httpForceReleaseLoading"/>
                                    <ButtonModule v-else-if="isButtonReactivate(slotProps.data)" type="primary" severity="normal" :label="(httpActivateLoading && currentlyProcessedSerialNumber === slotProps.data.serial_number) ? 'Re-Activating...' : 'Re-Activate'" @click="clickedReactivate(slotProps.data)" :disabled="httpActivateLoading || httpDeactivateLoading || httpForceReleaseLoading"/>
                                    <ButtonModule v-else-if="isButtonForceRelease(slotProps.data)" type="secondary" severity="danger" :label="(httpForceReleaseLoading && currentlyProcessedSerialNumber === slotProps.data.serial_number) ? 'Force Releasing...' : 'Force Release'" @click="clickedForceRelease(slotProps.data)" :disabled="httpActivateLoading || httpDeactivateLoading || httpForceReleaseLoading || isPendingNow(slotProps.data)"/>
                                    <ButtonModule v-else-if="isButtonForceReleaseDisabled(slotProps.data)" type="secondary" severity="danger" label="Force Release" disabled v-tooltip.left="{ value: `You can not force release an activation running with the old activation system.`, autoHide: false }"/>
                                    <span v-else>No action available...</span>
                                </div>
                            </template>
                        </Column>
                    </DataTable>
                </div>
            </div>

            <!-- DIALOGS -->

            <!-- Force Release license -->
            <ConfirmationForceReleaseDialog :showDialog="showConfirmationForceReleaseDialog" :license="licenseToForceRelease" @close="showConfirmationForceReleaseDialog = false" @force-release="(serialNumber, selectedReason, customizedReason) => confirmForceRelease(serialNumber, selectedReason, customizedReason)"/>

            <!-- Reactivate license -->
            <ConfirmationReactivateDialog :showDialog="showConfirmationReactivateDialog" :license="licenseToReactivate" @close="showConfirmationReactivateDialog = false" @reactivate="(serialNumber) => confirmReactivate(serialNumber)"/>

            <!-- Add Serial Number window -->
            <AddSerialNumberDialog :showDialog="showAddSerialNumberDialog" @close="showAddSerialNumberDialog = false"/>

        </div>
        <div v-else style="width: 100%; height: 100%;" class="flex justify-content-center align-items-center">
            <LoadingSpinner/>
        </div>

    </div>
    <div v-else style="margin-top: 2.5rem;">
        <span>You must sign in to have access to the dashboard with your licenses.</span>
    </div>
</template>

<script setup>
// --- IMPORTS ---
import { ref, computed, onMounted, onBeforeUnmount, watchEffect } from 'vue';
// PrimeVue
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Button from 'primevue/button';
import InputText from 'primevue/inputtext'
import Divider from 'primevue/divider'
import Dropdown from 'primevue/dropdown';
// Vue
import ScrollDescriptionText from '@/components/Licenses/Elements/ScrollDescriptionText.vue'
import StatusTag from '@/components/Licenses/Elements/StatusTag.vue'
import LoadingSpinner from '@/components/Modules/LoadingSpinner.vue';
import ButtonModule from '@/components/Modules/ButtonModule.vue';
import SvgRefresh from '@/components/SVGs/SvgRefresh.vue'
import ConfirmationForceReleaseDialog from '@/components/Dialogs/Actions/ConfirmationForceReleaseDialog.vue';
import ConfirmationReactivateDialog from '@/components/Dialogs/Actions/ConfirmationReactivateDialog.vue';
import AddSerialNumberDialog from '@/components/Dialogs/Actions/AddSerialNumberDialog.vue';
import SvgSearch from '@/components/SVGs/SvgSearch.vue'
import SvgCross from '@/components/SVGs/SvgCross.vue'
import SvgPlus from '@/components/SVGs/SvgPlus.vue'
// Others
import { useStore } from 'vuex';
import { useRouter } from 'vue-router'
import UserUtils from '@/composables/UserUtils';
import LicensesUtils from '@/composables/LicensesUtils';

const store = useStore()
const router = useRouter()
const { logoutUser } = UserUtils(store, router)
const { licensesSortingFunction, getLicenseRemainingPendingTimeLabel, isPendingNow } = LicensesUtils(store)
store.commit('applicationWebView/setIsWebView')

// Toast
import toastService from '@/composables/toastService';

// API
import useApiRequest from '@/composables/HTTPS/useApiRequest';
const { fetchGetApplicationLicenses, fetchActivate, fetchReactivate, fetchPing, fetchDeactivate, fetchForceRelease } = useApiRequest()
const httpGetApplicationLicensesLoading = ref(false)
const httpGetApplicationLicensesData = ref(null)
const httpActivateLoading = ref(false)
const httpActivateData = ref(null)
const httpReactivateLoading = ref(false)
const httpReactivateData = ref(null)
const httpDeactivateLoading = ref(false)
const httpDeactivateData = ref(null)
const httpPingLoading = ref(false)
const httpPingData = ref(null)
const httpForceReleaseLoading = ref(false)
const httpForceReleaseData = ref(null)

// --- Application and machine info ---
const user = computed(() => store.state.user.user)
const applicationCode = computed(() => store.state.applicationWebView.applicationCode)
const applicationBundleId = computed(() => store.state.applicationWebView.applicationBundleId)
const applicationInstanceId = computed(() => store.state.applicationWebView.applicationInstanceId)
const machineSerial = computed(() => store.state.applicationWebView.machineSerial)
const myLicenses = computed(() => store.state.applicationWebView.licenses)
const myCurrentActivationsSerials = computed(() => store.state.applicationWebView.currentActivationsSerials)

// --- Licenses : Load the licenses from the database (only the app I need !) + it loads the information to have for the application !  ---
const receivedEmptyArray = ref(false)
const loadApplicationLicenses = async () => {
    httpGetApplicationLicensesLoading.value = true
    try {
        httpGetApplicationLicensesData.value = await fetchGetApplicationLicenses({ application_code: applicationCode.value })
        receivedEmptyArray.value = (httpGetApplicationLicensesData.value.licenses.length == 0)
        store.commit('applicationWebView/setLicenses', httpGetApplicationLicensesData.value.licenses)
        store.commit('applicationWebView/setApplicationGlobalInfo', httpGetApplicationLicensesData.value.application_info)
        store.commit('applicationWebView/updateApplicationInstanceId')
    } catch (err) {
        handleGetApplicationLicensesError(err)
    } finally {
        httpGetApplicationLicensesLoading.value = false
    }
}
// Handle an error from the server
const handleGetApplicationLicensesError = (error) => {
    try {
        if (error.response == null) { // If there is no .response key, then it means it is not an error from the server, it did not reach it
            toastService.add({ severity: 'error', summary: `Get Application Licenses: Server not reachable.`, detail: `The server is not reachable. Please make sure you are connected to the internet. If you are, please try again.`, life: 5000 });
            return;
        }
        const errorStatus = error.response.status
        const errorCode = error.response.data.error_code
        const errorMessage = error.response.data.error_message
        switch (errorStatus) {
            case 400: // MISSING_OBJ / ACCESS_TOKEN_MISSING / MISSING_OBJ_ELEM (400)
                if (errorCode == 'ACCESS_TOKEN_MISSING') {
                    toastService.add({ severity: 'error', summary: "Get Application Licenses: Authorization Issue.", detail: 'You are not logged in.', life: 5000 });
                    // Logout
                    logoutUser()
                }
                else {  toastService.add({ severity: 'error', summary: `Get Application Licenses: Error ${errorStatus}.`, detail: errorMessage, life: 5000 }); }
                break;
            case 401: // ACCESS_TOKEN_EXPIRED / ACCESS_TOKEN_INVALID (401)
                if (errorCode == 'ACCESS_TOKEN_EXPIRED' || errorCode == 'ACCESS_TOKEN_INVALID') {
                    // Logout: Do nothing, the interceptor should have made a refresh token request!
                    // logoutUser()
                }
                else {  toastService.add({ severity: 'error', summary: `Get Application Licenses: Error ${errorStatus}.`, detail: errorMessage, life: 5000 }); }
                break;
            case 404: // ACCOUNT_NOT_FOUND (404)
                if (errorCode == 'ACCOUNT_NOT_FOUND') {
                    toastService.add({ severity: 'error', summary: "Get Application Licenses: Account Not Found.", detail: 'The account does not exist anymore.', life: 5000 });
                    // Logout
                    logoutUser()
                }
                else {  toastService.add({ severity: 'error', summary: `Get Application Licenses: Error ${errorStatus}.`, detail: errorMessage, life: 5000 }); }
                break;
            default:
                toastService.add({ severity: 'error', summary: `Get Application Licenses: Error ${errorStatus}.`, detail: errorMessage, life: 5000 });
                break;
        }
    } catch {
        toastService.add({ severity: 'error', summary: `Get Application Licenses: Server not reachable.`, detail: `The server is not reachable. Please make sure you are connected to the internet. If you are, please try again.`, life: 5000 });
    }
}

// --- Filtering process ---
// -- Status --
const selectionStatus = ref(null);
const optionsStatus = ref(['ALL', 'AVAILABLE', 'IN_USE_HERE', 'IN_USE_ELSEWHERE', 'IN_USE_OLD']);
watchEffect(() => {
    selectionStatus.value = selectionStatus.value == 'ALL' ? null : selectionStatus.value
})
// -- Search bar --
const searchValue = ref('')
// Filtering process
const myLicensesAfterFiltering = computed(() => {
    // Filter 0 : Search Field
    const filterSearch = (inputLicenses) => {
        if (searchValue.value === '') { return inputLicenses }
        else { 
            // Make a "string of interest" for each license (a string that concat all the string we want to check), and then check on that global string if the searched string is included or not
            // Map each license into its "string of interest"
            const stringsOfInterest = inputLicenses.map((license) => {
                let res = ""
                res = res + license.serial_number // Serial number
                res = res + license.product.options.map(option => option.label + option.abbrev).join('') // Options
                res = res + license.product.channels // Channels
                res = res + license.product.type // Type
                res = res + (license.product.exp !== '-1' ? license.product.exp : 'No Expiration') // Exp
                if (license.current_status.activated) {
                    if (license.current_status.activeUser) { res = res + license.current_status.activeUser.first_name + license.current_status.activeUser.last_name + license.current_status.activeUser.email } // Active user
                    if (license.current_status.activeHardware) { res = res + license.current_status.activeHardware.serial + license.current_status.activeHardware.label } // Active hardware
                    // res = res + license.current_status.activationTimestamp// Activation date
                }
                return res.toLowerCase()
            })
            return inputLicenses.filter((license, index) => stringsOfInterest[index].includes(searchValue.value.toLowerCase()))
        }
    }
    // Filter 1 : Status
    const filterStatus = (inputLicenses) => {
        if (selectionStatus.value == null || (selectionStatus.value && selectionStatus.value == 'ALL')) { return inputLicenses; }
        else if (selectionStatus.value == 'AVAILABLE') { return inputLicenses.filter((license) => license.current_status.activated === false); }
        else if (selectionStatus.value == 'IN_USE_HERE') { 
            return inputLicenses.filter((license) => {
                const isActivated = license.current_status.activated
                if (!isActivated) { return false; }
                const isCurrentMachine = isActivated && license.current_status.activeHardware && machineSerial.value == license.current_status.activeHardware.serial
                if (!isCurrentMachine) { return false; }
                const isCurrentMachineAndApplication = isCurrentMachine && ((license.current_status.application_instance_id ? license.current_status.application_instance_id : 0) == applicationInstanceId.value)
                // const isLocallyActivated = myCurrentActivationsSerials.value.includes(license.serial_number)
                // return isCurrentMachineAndApplication && isLocallyActivated
                return isCurrentMachineAndApplication // I want to see the "Should be Re-Activated" with the IN_USE_HERE because it is supposed to be in use here
            });
        }
        else if (selectionStatus.value == 'IN_USE_ELSEWHERE') { // It is "elsewhere" but still in the NEW system, not the old one
            return inputLicenses.filter((license) => {
                const isActivated = license.current_status.activated
                if (!isActivated) { return false; }
                const isOldSystemActivation = isActivated && !license.current_status.activeUser && !license.current_status.activeHardware && !license.current_status.activationTimestamp
                if (isOldSystemActivation) { return false; }
                const isCurrentMachine = isActivated && license.current_status.activeHardware && machineSerial.value == license.current_status.activeHardware.serial
                if (!isCurrentMachine) { return true; }
                const isCurrentMachineAndApplication = isCurrentMachine && ((license.current_status.application_instance_id ? license.current_status.application_instance_id : 0) == applicationInstanceId.value)
                return !isCurrentMachineAndApplication
            });
        }
        else if (selectionStatus.value == 'IN_USE_OLD') { 
            return inputLicenses.filter((license) => {
                const isActivated = license.current_status.activated
                if (!isActivated) { return false; }
                const isOldSystemActivation = isActivated && !license.current_status.activeUser && !license.current_status.activeHardware && !license.current_status.activationTimestamp
                return isOldSystemActivation
            });
        }
        return inputLicenses
    }
    // Filter processing
    return filterSearch(filterStatus(myLicenses.value))
})

// --- Know which button to show ---
const isButtonActivate = (license) => {
    return !license.current_status.activated
}
const isButtonRelease = (license) => {
    return license.current_status.activated && license.current_status.activeHardware && license.current_status.activeHardware.serial == machineSerial.value && license.current_status.application_bundle_id && license.current_status.application_bundle_id == applicationBundleId.value && myCurrentActivationsSerials.value.includes(license.serial_number)
}
const isButtonReactivate = (license) => {
    return license.current_status.activated && license.current_status.activeHardware && license.current_status.activeHardware.serial == machineSerial.value && license.current_status.application_bundle_id && license.current_status.application_bundle_id == applicationBundleId.value && !myCurrentActivationsSerials.value.includes(license.serial_number)
}
const isButtonForceRelease = (license) => {
    return license.current_status.activated && ((license.current_status.activeHardware && license.current_status.activeHardware.serial != machineSerial.value) || (license.current_status.application_bundle_id && license.current_status.application_bundle_id != applicationBundleId.value))
}
const isButtonForceReleaseDisabled = (license) => {
    return license.current_status.activated && !license.current_status.activeUser && !license.current_status.activeHardware && !license.current_status.activationTimestamp
}


// -- TRACK POTENTIAL PENDING --
const myLicensesAfterFilteringAndPendingUpdating = ref([])
let timeoutId;
onMounted(() => {
  function updatePotentialPendingTime() {
    myLicensesAfterFilteringAndPendingUpdating.value = myLicensesAfterFiltering.value.map((license) => {
        if (license.pending) {
            return {
                ...license,
                pending: {
                    ...license.pending,
                    pending_remaining_time: getLicenseRemainingPendingTimeLabel(license.pending.pending_exp_datetime)
                }
            }  
        }
        else {
            return license
        }
    })
    // Execute this function again after 1 second
    timeoutId = setTimeout(updatePotentialPendingTime, 1000);
  }
  // Start the interval
  updatePotentialPendingTime();
})
onBeforeUnmount(() => {
  // Clear the timeout when the component is unmounted
  if (timeoutId) {
    clearTimeout(timeoutId);
  }
});
watchEffect(() => {
    if (myLicensesAfterFiltering.value) { 
        myLicensesAfterFilteringAndPendingUpdating.value = myLicensesAfterFiltering.value.map((license) => {
            if (license.pending) {
                return {
                    ...license,
                    pending: {
                        ...license.pending,
                        pending_remaining_time: getLicenseRemainingPendingTimeLabel(license.pending.pending_exp_datetime)
                    }
                }  
            }
            else {
                return license
            }
        })
    }
})

// --- Refresh licenses ---
const refreshApplicationLicenses = async () => {
    store.commit('applicationWebView/clearLicenses')
    // Load licenses
    if (user.value && applicationCode.value) {
        // Initialize loading
        httpGetApplicationLicensesLoading.value = true
        await loadApplicationLicenses();
    } else {
        toastService.add({ severity: 'error', summary: `Refresh Application Licenses: Error.`, detail: `Unexpected issue. Please close and re-open the window to solve it.`, life: 5000 });
    }
    // Load licenses info from Application
    retrieveCurrentActivationsSerialsFromApp()
}
const retrieveCurrentActivationsSerialsFromApp = () => {
    if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.jsGetCurrentActivationsSerials) {
        window.webkit.messageHandlers.jsGetCurrentActivationsSerials.postMessage(null);
    }
}
window.appSentCurrentActivationsSerials = async (info) => {
    if (info.current_activations_serials) { store.commit('applicationWebView/setCurrentActivationsSerials', info.current_activations_serials) }
}

// On Mounted : load the licenses
onMounted(() => {
    // Set WebView size
    if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.jsResizeWindow) {
        window.webkit.messageHandlers.jsResizeWindow.postMessage({ width: 1150, height: 700 });
    }
    refreshApplicationLicenses()
})

// --- Add a Serial Number ---
const showAddSerialNumberDialog = ref(false)

// Currently processed serial number
const currentlyProcessedSerialNumber = ref(null)


// --- ACTIVATION ---

// (1) FROM JS TO OBJC : Ask the activation record to the ObjC app.
const clickedActivate = (license) => {
    if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.jsActivateAction) {
        currentlyProcessedSerialNumber.value = license.serial_number
        window.webkit.messageHandlers.jsActivateAction.postMessage(license.serial_number);
    }
}
// (2) FROM OBJC TO JS : ObjC app responds with the activation record
window.appSentActivationRecord = async (activationRecord) => {
    // (3) FROM JS TO SERVER : Make the activation request to the server
    httpActivateLoading.value = true
    try {
        httpActivateData.value = await fetchActivate({ activation_record: activationRecord })
        let serialNumber = httpActivateData.value.serial_number
        let currentStatus = httpActivateData.value.current_status
        let pending = httpActivateData.value.pending
        let activationToken = httpActivateData.value.activation_token
        let description = httpActivateData.value.description

        // Update current_status
        store.commit('applicationWebView/addCurrentActivationSerial', serialNumber )
        store.commit('applicationWebView/updateLicenseCurrentStatusAndPendingInfo', { serial_number: serialNumber, current_status: currentStatus, pending: pending } )

        // (4) FROM JS TO OBJC : Tell the server response to the ObjC
        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.jsActivationSuccess) {
            window.webkit.messageHandlers.jsActivationSuccess.postMessage({ serial_number: serialNumber, activation_token: activationToken, description: description });
        }
        // TODO: Add things to do
    } catch (err) {
        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.jsActivationFailed) {
            window.webkit.messageHandlers.jsActivationFailed.postMessage(null);
        }
        handleActivateError(err)
    } finally {
        httpActivateLoading.value = false
        currentlyProcessedSerialNumber.value = null
        retrieveCurrentActivationsSerialsFromApp()
    }
};
// Handle an error from the server
const handleActivateError = (error) => {
    try {
        if (error.response == null) { // If there is no .response key, then it means it is not an error from the server, it did not reach it
            toastService.add({ severity: 'error', summary: `Activation: Server not reachable.`, detail: `The server is not reachable. Please make sure you are connected to the internet. If you are, please try again.`, life: 5000 });
            return;
        }
        const errorStatus = error.response.status
        const errorCode = error.response.data.error_code
        const errorMessage = error.response.data.error_message
        switch (errorStatus) {
            case 400: // MISSING_OBJ / ACCESS_TOKEN_MISSING / MISSING_OBJ_ELEM (400)
                if (errorCode == 'ACCESS_TOKEN_MISSING') {
                    toastService.add({ severity: 'error', summary: "Activation: Authorization Issue.", detail: 'You are not logged in.', life: 5000 });
                    // Logout
                    logoutUser()
                }
                else {  toastService.add({ severity: 'error', summary: `Activation: Error ${errorStatus}.`, detail: errorMessage, life: 5000 }); }
                break;
            case 401: // ACCESS_TOKEN_EXPIRED / ACCESS_TOKEN_INVALID (401)
                if (errorCode == 'ACCESS_TOKEN_EXPIRED' || errorCode == 'ACCESS_TOKEN_INVALID') {
                    // Logout: Do nothing, the interceptor should have made a refresh token request!
                    // logoutUser()
                }
                else {  toastService.add({ severity: 'error', summary: `Activation: Error ${errorStatus}.`, detail: errorMessage, life: 5000 }); }
                break;
            case 404: // ACCOUNT_NOT_FOUND / SERIAL_INVALID (404)
                if (errorCode == 'ACCOUNT_NOT_FOUND') {
                    toastService.add({ severity: 'error', summary: "Activation: Account Not Found.", detail: 'The account does not exist anymore.', life: 5000 });
                    // Logout
                    logoutUser()
                }
                else if (errorCode == 'SERIAL_INVALID') {
                    toastService.add({ severity: 'error', summary: "Activation: Invalid Serial Number.", detail: errorMessage, life: 5000 });
                }
                else { toastService.add({ severity: 'error', summary: `Activation: Error ${errorStatus}.`, detail: errorMessage, life: 5000 }); }
                break;
            case 409: // LICENSE_IN_USE (409)
                if (errorCode == 'LICENSE_IN_USE') {
                    toastService.add({ severity: 'error', summary: "Activation: License is already in use.", detail: errorMessage, life: 5000 });
                    // Since there is a conflict, we update the status we have by refreshing...
                    refreshApplicationLicenses()
                }
                else {  toastService.add({ severity: 'error', summary: `Activation: Error ${errorStatus}.`, detail: errorMessage, life: 5000 }); }
                break;
            case 500: // INTERNAL_ERROR / DATABASE_ERROR (500) => toast
                if (errorCode == 'INTERNAL_ERROR' || errorCode == 'DATABASE_ERROR') {
                    toastService.add({ severity: 'error', summary: "Activation: Internal Error.", detail: 'Sorry, it seems that there is an internal error. Please try later.', life: 5000 });
                }
                else {  toastService.add({ severity: 'error', summary: `Activation: Error ${errorStatus}.`, detail: errorMessage, life: 5000 }); }
                break;
            default:
                toastService.add({ severity: 'error', summary: `Activation: Error ${errorStatus}.`, detail: errorMessage, life: 5000 });
                break;
        }
    } catch {
        toastService.add({ severity: 'error', summary: `Activation: Server not reachable.`, detail: `The server is not reachable. Please make sure you are connected to the internet. If you are, please try again.`, life: 5000 });
    }
}


// --- RE-ACTIVATION ---
const licenseToReactivate = ref(null)
const showConfirmationReactivateDialog = ref(false)
const clickedReactivate = (license) => {
    licenseToReactivate.value = license
    showConfirmationReactivateDialog.value = true
}
// (1) FROM JS TO OBJC : Ask the reactivation record to the ObjC app.
const confirmReactivate = (serialNumber) => {
    showConfirmationReactivateDialog.value = false
    licenseToReactivate.value = null
    if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.jsReactivateAction) {
        currentlyProcessedSerialNumber.value = serialNumber
        window.webkit.messageHandlers.jsReactivateAction.postMessage(serialNumber);
    }
}
// (2) FROM OBJC TO JS : ObjC app responds with the reactivation record
window.appSentReactivationRecord = async (reactivationRecord) => {
    // (3) FROM JS TO SERVER : Make the reactivation request to the server
    httpReactivateLoading.value = true
    try {
        httpReactivateData.value = await fetchReactivate({ reactivation_record: reactivationRecord })

        let serialNumber = httpReactivateData.value.serial_number
        let currentStatus = httpReactivateData.value.current_status
        let pending = httpReactivateData.value.pending
        let activationToken = httpReactivateData.value.activation_token
        let description = httpReactivateData.value.description

        // Update current_status
        store.commit('applicationWebView/addCurrentActivationSerial', serialNumber )
        store.commit('applicationWebView/updateLicenseCurrentStatusAndPendingInfo', { serial_number: serialNumber, current_status: currentStatus, pending: pending } )

        // (4) FROM JS TO OBJC : Tell the server response to the ObjC
        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.jsReactivationSuccess) {
            window.webkit.messageHandlers.jsReactivationSuccess.postMessage({ serial_number: serialNumber, activation_token: activationToken, description: description });
        }
        // TODO: Add things to do
    } catch (err) {
        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.jsReactivationFailed) {
            window.webkit.messageHandlers.jsReactivationFailed.postMessage(null);
        }
        handleReactivateError(err)
    } finally {
        httpReactivateLoading.value = false
        currentlyProcessedSerialNumber.value = null
        retrieveCurrentActivationsSerialsFromApp()
    }
};
// Handle an error from the server
const handleReactivateError = (error) => {
    try {
        if (error.response == null) { // If there is no .response key, then it means it is not an error from the server, it did not reach it
            toastService.add({ severity: 'error', summary: `Reactivation: Server not reachable.`, detail: `The server is not reachable. Please make sure you are connected to the internet. If you are, please try again.`, life: 5000 });
            return;
        }
        const errorStatus = error.response.status
        const errorCode = error.response.data.error_code
        const errorMessage = error.response.data.error_message
        switch (errorStatus) {
            case 400: // MISSING_OBJ / ACCESS_TOKEN_MISSING / MISSING_OBJ_ELEM (400)
                if (errorCode == 'ACCESS_TOKEN_MISSING') {
                    toastService.add({ severity: 'error', summary: "Reactivation: Authorization Issue.", detail: 'You are not logged in. Please log in and try again.', life: 5000 });
                    // Logout
                    logoutUser()
                }
                else {  toastService.add({ severity: 'error', summary: `Reactivation: Error ${errorStatus}.`, detail: errorMessage, life: 5000 }); }
                break;
            case 401: // ACCESS_TOKEN_EXPIRED / ACCESS_TOKEN_INVALID (401)
                if (errorCode == 'ACCESS_TOKEN_EXPIRED' || errorCode == 'ACCESS_TOKEN_INVALID') {
                    // Logout: Do nothing, the interceptor should have made a refresh token request!
                    // logoutUser()
                }
                else {  toastService.add({ severity: 'error', summary: `Reactivation: Error ${errorStatus}.`, detail: errorMessage, life: 5000 }); }
                break;
            case 403: // REACTIVATION_NOT_AUTHORIZED (403)
                if (errorCode == 'REACTIVATION_NOT_AUTHORIZED') {
                    toastService.add({ severity: 'error', summary: `Reactivation: Unauthorized.`, detail: errorMessage, life: 5000 });
                }
                else {  toastService.add({ severity: 'error', summary: `Reactivation: Error ${errorStatus}.`, detail: errorMessage, life: 5000 }); }
                break;
            case 404: // ACCOUNT_NOT_FOUND / SERIAL_INVALID / ACTIVATION_NOT_FOUND (404)
                if (errorCode == 'ACCOUNT_NOT_FOUND') {
                    toastService.add({ severity: 'error', summary: "Reactivation: Account Not Found.", detail: 'The account does not exist anymore.', life: 5000 });
                    // Logout
                    logoutUser()
                }
                else if (errorCode == 'SERIAL_INVALID') {
                    toastService.add({ severity: 'error', summary: "Reactivation: Invalid Serial Number.", detail: errorMessage, life: 5000 });
                }
                else if (errorCode == 'ACTIVATION_NOT_FOUND') {
                    toastService.add({ severity: 'error', summary: "Reactivation: Old activation could not be found.", detail: errorMessage, life: 5000 });
                }
                else { toastService.add({ severity: 'error', summary: `Reactivation: Error ${errorStatus}.`, detail: errorMessage, life: 5000 }); }
                break;
            case 500: // INTERNAL_ERROR / DATABASE_ERROR (500) => toast
                if (errorCode == 'INTERNAL_ERROR' || errorCode == 'DATABASE_ERROR') {
                    toastService.add({ severity: 'error', summary: "Reactivation: Internal Error.", detail: 'Sorry, it seems that there is an internal error. Please try again later.', life: 5000 });
                }
                else {  toastService.add({ severity: 'error', summary: `Reactivation: Error ${errorStatus}.`, detail: errorMessage, life: 5000 }); }
                break;
            default:
                toastService.add({ severity: 'error', summary: `Reactivation: Error ${errorStatus}.`, detail: errorMessage, life: 5000 });
                break;
        }
    } catch {
        toastService.add({ severity: 'error', summary: `Reactivation: Server not reachable.`, detail: `The server is not reachable. Please make sure you are connected to the internet. If you are, please try again.`, life: 5000 });
    }
}


// --- DEACTIVATION ---
const licenseToRelease = ref(null)
// (1) FROM JS TO OBJC : Ask the activation token to the ObjC app.
const clickedRelease = async (serialNumber) => {
    // MAKE A PING TO MAKE SURE WE ARE CONNECTED AND THE SERVER IS REACHABLE !
    httpPingLoading.value = true
    try {
        httpPingData.value = await fetchPing()
        // If we are here, it means that the ping is successful ! We can reactivate
        licenseToRelease.value = null
        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.jsDeactivateAction) {
            currentlyProcessedSerialNumber.value = serialNumber
            window.webkit.messageHandlers.jsDeactivateAction.postMessage(serialNumber);
        }
    } catch (err) {
        toastService.add({ severity: 'error', summary: `Release: Softron License Manager can not be reached.`, detail: `Softron License Manager can not be reached. Please make sure you are connected to the internet. If you are, please try again.`, life: 5000 });
    } finally {
        httpPingLoading.value = false
    }
}
// (2) FROM OBJC TO JS : ObjC app responds with the activation token to be sent for the deactivation
window.appSentDeactivationRecord = async (deactivationRecord) => {
    // (3) FROM JS TO SERVER : Make the deactivation request to the server
    httpDeactivateLoading.value = true
    try {
        httpDeactivateData.value = await fetchDeactivate({ deactivation_record: deactivationRecord })

        let serialNumber = httpDeactivateData.value.serial_number
        let currentStatus = httpDeactivateData.value.current_status
        let pending = httpDeactivateData.value.pending

        // Update current_status
        // (First update in the myLicensesAfterFilteringSorted. If we don't, it still works, however since we change in the store, and then compute myLicense, and then filter and update pending, it takes time to update in the table directly...)
        myLicensesAfterFilteringAndPendingUpdating.value = myLicensesAfterFilteringAndPendingUpdating.value.map((license) => {
            if (license.serial_number === serialNumber) {
                return { ...license, ['current_status']: currentStatus }
            }
            return license
        })
        // (Then we still update in the store, such as we keep a correct track of all the licenses here)
        store.commit('applicationWebView/updateLicenseCurrentStatusAndPendingInfo', { serial_number: serialNumber, current_status: currentStatus, pending: pending } ) // (Then we still update in the store, such as we keep a correct track of all the licenses here)
        store.commit('applicationWebView/removeCurrentActivationSerial', serialNumber )

        // (4) FROM JS TO OBJC : Tell the server response to the ObjC
        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.jsDeactivationSuccess) {
            window.webkit.messageHandlers.jsDeactivationSuccess.postMessage(serialNumber);
        }
        // TODO: Add things to do
    } catch (err) {
        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.jsDeactivationFailed) {
            window.webkit.messageHandlers.jsDeactivationFailed.postMessage(null);
        }
        handleDeactivateError(err)
    } finally {
        httpDeactivateLoading.value = false
        currentlyProcessedSerialNumber.value = null
        retrieveCurrentActivationsSerialsFromApp()
    }
};
// Handle an error from the server
const handleDeactivateError = (error) => {
    try {
        if (error.response == null) { // If there is no .response key, then it means it is not an error from the server, it did not reach it
            toastService.add({ severity: 'error', summary: `Release: Server not reachable.`, detail: `The server is not reachable. Please make sure you are connected to the internet. If you are, please try again.`, life: 5000 });
            return;
        }
        const errorStatus = error.response.status
        const errorCode = error.response.data.error_code
        const errorMessage = error.response.data.error_message
        switch (errorStatus) {
            case 400: // MISSING_OBJ / ACCESS_TOKEN_MISSING / MISSING_OBJ_ELEM (400)
                if (errorCode == 'ACCESS_TOKEN_MISSING') {
                    toastService.add({ severity: 'error', summary: "Release: Authorization Issue.", detail: 'You are not logged in.', life: 5000 });
                    // Logout
                    logoutUser()
                }
                else {  toastService.add({ severity: 'error', summary: `Release: Error ${errorStatus}.`, detail: errorMessage, life: 5000 }); }
                break;
            case 401: // ACCESS_TOKEN_EXPIRED / ACCESS_TOKEN_INVALID / USER_NOT_OWNER_NOT_DELEGATE / LICENSE_NOT_IN_USE (401)
                if (errorCode == 'ACCESS_TOKEN_EXPIRED' || errorCode == 'ACCESS_TOKEN_INVALID') {
                    // Logout: Do nothing, the interceptor should have made a refresh token request!
                    // logoutUser()
                }
                else if (errorCode == 'USER_NOT_OWNER_NOT_DELEGATE') {
                    toastService.add({ severity: 'error', summary: `Release: Not Authorized.`, detail: errorMessage, life: 5000 });
                    // Since there is a conflict, we update the status we have by refreshing...
                    refreshApplicationLicenses()
                }
                else if (errorCode == 'LICENSE_NOT_IN_USE') {
                    toastService.add({ severity: 'error', summary: `Release: License Not Running.`, detail: errorMessage, life: 5000 });
                    // Since there is a conflict, we update the status we have by refreshing...
                    refreshApplicationLicenses()
                }
                else {  toastService.add({ severity: 'error', summary: `Release: Error ${errorStatus}.`, detail: errorMessage, life: 5000 }); }
                break;
            case 403: // INVALID_ACTIVATION_TOKEN (403)
                if (errorCode == 'INVALID_ACTIVATION_TOKEN') {
                    toastService.add({ severity: 'error', summary: `Release: Activation Issue.`, detail: errorMessage, life: 5000 });
                }
                else { toastService.add({ severity: 'error', summary: `Release: Error ${errorStatus}.`, detail: errorMessage, life: 5000 }); }
                break;
            case 404: // ACCOUNT_NOT_FOUND (404)
                if (errorCode == 'ACCOUNT_NOT_FOUND') {
                    toastService.add({ severity: 'error', summary: "Release: Account Not Found.", detail: 'The account does not exist anymore.', life: 5000 });
                    // Logout
                    logoutUser()
                }
                else { toastService.add({ severity: 'error', summary: `Release: Error ${errorStatus}.`, detail: errorMessage, life: 5000 }); }
                break;
            case 500: // DATABASE_ERROR (500) => toast
                if (errorCode == 'DATABASE_ERROR') {
                    toastService.add({ severity: 'error', summary: "Release: Internal Error.", detail: 'Sorry, it seems that there is an internal error. Please try again later.', life: 5000 });
                }
                else {  toastService.add({ severity: 'error', summary: `Release: Error ${errorStatus}.`, detail: errorMessage, life: 5000 }); }
                break;
            default:
                toastService.add({ severity: 'error', summary: `Release: Error ${errorStatus}.`, detail: errorMessage, life: 5000 });
                break;
        }
    } catch {
        toastService.add({ severity: 'error', summary: `Release: Server not reachable.`, detail: `The server is not reachable. Please make sure you are connected to the internet. If you are, please try again.`, life: 5000 });
    }
}


// --- FORCE RELEASE ---
const licenseToForceRelease = ref(null)
const showConfirmationForceReleaseDialog = ref(false)
const clickedForceRelease = (license) => {
    licenseToForceRelease.value = license
    showConfirmationForceReleaseDialog.value = true
}
// FROM JS TO SERVER : Make the force release request to the server
const confirmForceRelease = async (serialNumber, selectedReason, customizedReason) => {
    currentlyProcessedSerialNumber.value = serialNumber
    // Send HTTP request with passwordVerification
    httpForceReleaseLoading.value = true
    try {
        let requestInfo = { selected_reason: selectedReason, license_serial_number: serialNumber, from_webview: true }
        if (selectedReason == "ANOTHER_REASON") { requestInfo = { ...requestInfo, customized_reason: customizedReason } }
        httpForceReleaseData.value = await fetchForceRelease(requestInfo)
        // Reset of values
        showConfirmationForceReleaseDialog.value = false
        licenseToForceRelease.value = false
        // Refresh of data
        store.commit('applicationWebView/updateLicenseCurrentStatusAndPendingInfo', { serial_number: serialNumber, current_status: httpForceReleaseData.value.license_updated.current_status, pending: httpForceReleaseData.value.license_updated.pending} )
        // Success toast
        //toastService.add({ severity: 'success', summary: "Force Release: Success", detail: 'The license has been successfully force released.', life: 5000 });
    } catch (err) {
        handleForceReleaseError(err)
    } finally {
      httpForceReleaseLoading.value = false
      currentlyProcessedSerialNumber.value = null
    }
}
// Handle an error from the server
const handleForceReleaseError = (error) => {
    try {
        if (error.response == null) { // If there is no .response key, then it means it is not an error from the server, it did not reach it
            toastService.add({ severity: 'error', summary: `Force Release: Server not reachable.`, detail: `The server is not reachable. Please make sure you are connected to the internet. If you are, please try again.`, life: 5000 });
            return;
        }
        const errorStatus = error.response.status
        const errorCode = error.response.data.error_code
        const errorMessage = error.response.data.error_message
        switch (errorStatus) {
            case 400: // ACCESS_TOKEN_MISSING / MISSING_OBJ / MISSING_OBJ_ELEM (400)
                if (errorCode == 'ACCESS_TOKEN_MISSING') {
                    toastService.add({ severity: 'error', summary: "Force Release: Authorization Issue.", detail: 'You are not logged in.', life: 5000 });
                    // Logout
                    logoutUser()
                }
                else if (errorCode == 'MISSING_OBJ' || errorCode == 'MISSING_OBJ_ELEM') { // MISSING_OBJ / MISSING_OBJ_ELEM
                    toastService.add({ severity: 'warn', summary: "Force Release: Missing Information.", detail: 'It seems that the request body does not contain the required information.', life: 5000 });
                }
                else { toastService.add({ severity: 'error', summary: `Force Release: Error ${errorStatus}.`, detail: errorMessage, life: 5000 }); }
                break;
            case 401: // USER_NOT_OWNER_NOT_DELEGATE / LICENSE_NOT_IN_USE / ACCESS_TOKEN_EXPIRED / ACCESS_TOKEN_INVALID (401)
                if (errorCode == 'USER_NOT_OWNER_NOT_DELEGATE') { // USER_NOT_OWNER_NOT_DELEGATE
                    showConfirmationForceReleaseDialog.value = false
                    toastService.add({ severity: 'error', summary: "Force Release: Not Authorized.", detail: errorMessage, life: 5000 });
                    refreshApplicationLicenses()
                }
                else if (errorCode == 'LICENSE_NOT_IN_USE') { // LICENSE_NOT_IN_USE
                    showConfirmationForceReleaseDialog.value = false
                    toastService.add({ severity: 'warn', summary: "Force Release: License is not in use.", detail: errorMessage, life: 5000 });
                    refreshApplicationLicenses()
                }
                else if (errorCode == 'ACCESS_TOKEN_EXPIRED' || errorCode == 'ACCESS_TOKEN_INVALID') { // ACCESS_TOKEN_EXPIRED / ACCESS_TOKEN_INVALID
                    // Logout: Do nothing, the interceptor should have made a refresh token request!
                    // logoutUser()
                }
                else { toastService.add({ severity: 'error', summary: `Force Release: Error ${errorStatus}.`, detail: errorMessage, life: 5000 }); }
                break;
            case 403: // FORCE_RELEASE_NOT_AUTHORIZED (401)
                if (errorCode == 'FORCE_RELEASE_NOT_AUTHORIZED') { // FORCE_RELEASE_NOT_AUTHORIZED
                    showConfirmationForceReleaseDialog.value = false
                    toastService.add({ severity: 'error', summary: "Force Release: Can't Release.", detail: errorMessage, life: 5000 });
                    refreshApplicationLicenses()
                }
                else { toastService.add({ severity: 'error', summary: `Force Release: Error ${errorStatus}.`, detail: errorMessage, life: 5000 }); }
                break;
            case 404: // ACCOUNT_NOT_FOUND / SERIAL_INVALID / NOT_FOUND (404)
                if (errorCode == 'SERIAL_INVALID') { // SERIAL_INVALID
                    showConfirmationForceReleaseDialog.value = false
                    toastService.add({ severity: 'error', summary: "Force Release: Invalid Serial Number.", detail: 'The license is not valid or has been deleted from the database.', life: 5000 });
                    store.commit('licenses/removeLicense', license.value.serial_number)
                    refreshApplicationLicenses()
                }
                else if (errorCode == 'ACCOUNT_NOT_FOUND') { // ACCOUNT_NOT_FOUND
                    toastService.add({ severity: 'error', summary: "Force Release: Account Not Found.", detail: 'The account does not exist anymore.', life: 5000 });
                    // Logout
                    logoutUser()
                }
                else { toastService.add({ severity: 'error', summary: `Force Release: Error ${errorStatus}.`, detail: errorMessage, life: 5000 }); }
                break;
            case 500: // DATABASE_ERROR / INTERNAL_ERROR (500) => toast
                if (errorCode == 'DATABASE_ERROR' || errorCode == 'INTERNAL_ERROR') { // DATABASE_ERROR / INTERNAL_ERROR
                    toastService.add({ severity: 'error', summary: "Force Release: Internal Error.", detail: 'Sorry, it seems that there is an internal error. Please try again later.', life: 5000 });
                }
                else { toastService.add({ severity: 'error', summary: `Force Release: Error ${errorStatus}.`, detail: errorMessage, life: 5000 }); }
                break;
            default:
                toastService.add({ severity: 'error', summary: `Force Release: Error ${errorStatus}.`, detail: errorMessage, life: 5000 });
                break;
        }
    } catch {
        toastService.add({ severity: 'error', summary: `Force Release: Server not reachable.`, detail: `The server is not reachable. Please make sure you are connected to the internet. If you are, please try again.`, life: 5000 });
    }
}

// -- SORT --
const myLicensesAfterFilteringAndPendingUpdatingSorted = computed(() => {
    return [...myLicensesAfterFilteringAndPendingUpdating.value].sort(licensesSortingFunction)
})

// -- WINDOW HEIGHT TRACKING --
const windowHeight = ref(window.innerHeight);
const updateWindowHeight = () => {
  windowHeight.value = window.innerHeight;
};
// Add event listener on mount and remove it on unmount
onMounted(() => {
  window.addEventListener('resize', updateWindowHeight);
});
onBeforeUnmount(() => {
  window.removeEventListener('resize', updateWindowHeight);
});
</script>

<style scoped>
/* Status Dropdown */
:deep(.p-dropdown .p-dropdown-label) {
    padding: 0rem 0.2rem;
}
:deep(.p-dropdown .p-dropdown-trigger svg) {
    color: var(--theme-font-color);
}
/* Columns header */
:deep(.p-resizable-column) {
    padding: 16px 5px;
}
:deep(.resize .p-column-resizer) {
    background-color: var(--table-column-separator-color);
    margin-top: 0.4rem;
    height: 80%;
    width: 0.03rem;
    margin-right: 0.1rem;
}
:deep(.row) {
    height: 2rem;
}
:deep(.p-datatable .p-datatable-tbody td) {
    padding: 0rem 0.4rem;
}
</style>